import client from './api-client';

export const serviceObtieneParametro = async (parametro) => {
    const query = Buffer.from(JSON.stringify({ rutcia: 0, parametro })).toString('base64');
    const response = await client.get(`parametros?q=${query}`);

    if (response.status === 200 && response.data.code === 1) return Number(response.data.object.valorParametro) * 1000000;
    else throw new Error(response.data.message);
}
